import script from "./welcomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./welcomeView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__